function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoSearch = function SvgInfoSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 13 13"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h13v13H0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8 4.664h1.062V5.73H6.8Zm0 2.136h1.062V10H6.8ZM7.329 2a5.329 5.329 0 1 0 5.329 5.329A5.33 5.33 0 0 0 7.329 2m0 9.592a4.263 4.263 0 1 1 4.263-4.263 4.27 4.27 0 0 1-4.263 4.263",
    style: {
      fill: "#4553a9"
    },
    transform: "translate(-.829 -.829)"
  }));
};
export { SvgInfoSearch as Icon };
export default __webpack_public_path__ + "static/media/aecd04ef8d95279ccb73a24927573d6b.svg";